export function getIcfVersionDisplayLabel(version) {
  if (!version) return 'v1';
  if (version.label) return version.label;
  const n = version.globalVersionNumber || version.versionNumber || 1;
  return `v${n}`;
}

export function sortIcfVersionsNewestFirst(versions) {
  return [...(versions || [])].sort((a, b) => {
    const aGlobal = a.globalVersionNumber || a.versionNumber || 0;
    const bGlobal = b.globalVersionNumber || b.versionNumber || 0;
    if (aGlobal !== bGlobal) return bGlobal - aGlobal;
    if ((b.versionNumber || 0) !== (a.versionNumber || 0)) {
      return (b.versionNumber || 0) - (a.versionNumber || 0);
    }
    const aTime = a.createdAt ? new Date(a.createdAt).getTime() : 0;
    const bTime = b.createdAt ? new Date(b.createdAt).getTime() : 0;
    return bTime - aTime;
  });
}

export function getLatestIcfVersionLabel(section) {
  const sorted = sortIcfVersionsNewestFirst(section?.versions);
  if (!sorted.length) return null;
  return getIcfVersionDisplayLabel(sorted[0]);
}

export function getIcfVersionRowKey(version, index = 0) {
  if (version?._id) return String(version._id);
  return `v-${version?.globalVersionNumber || version?.versionNumber || index}-${version?.createdAt || index}`;
}
